<script>
export default {
  props: {
    templateHtml: {
      type: String,
      default: ''
    },
    marker: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    this.$options.template = this.templateHtml
  }
}
</script>
